import { render, staticRenderFns } from "./ColumnsSelectColumnItem.vue?vue&type=template&id=5b9ed007"
import script from "./ColumnsSelectColumnItem.vue?vue&type=script&lang=js"
export * from "./ColumnsSelectColumnItem.vue?vue&type=script&lang=js"
import style0 from "./ColumnsSelectColumnItem.vue?vue&type=style&index=0&id=5b9ed007&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports